import * as React from 'react';
import { Autocomplete, Box, Container, Grid, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Tabs, Tab } from "@mui/material"
import Bottom from "./Bottom";
import { useEffect } from "react";
import api from "../utils/api";

import useComparisonHospitalStore from "../store/ComparisonHospitalStore";
import tab03 from "../assets/images/tab_04.png"
import information_01 from '../assets/images/imformation_01.png'
import information_02 from '../assets/images/imformation_02.png'

import infor_01 from '../assets/images/infor_01.png'
import infor_02 from '../assets/images/infor_02.png'
import infor_03 from '../assets/images/infor_03.png'
import infor_04 from '../assets/images/infor_04.png'
import infor_05 from '../assets/images/infor_05.png'
import infor_06 from '../assets/images/infor_06.png'
import infor_07 from '../assets/images/infor_07.png'
import infor_08 from '../assets/images/infor_08.png'
import infor_09 from '../assets/images/infor_09.png'
import infor_10 from '../assets/images/infor_10.png'
import infor_11 from '../assets/images/infor_11.png'
import BorderColor from '@mui/icons-material/BorderColor';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


const Information = () => {

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };


  return (
    <Container className="container">
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900, }}>
              이용안내
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              건강검진안내
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Container className="White_box" sx={{width: '80%', mr : 'auto',  ml : 'auto'}}>
        <Grid container>
          <Grid container className='wb_container'>

            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example "  sx={{ '& button' : {color: '#0d6703!important', fontSize: 16}, '& .css-1aquho2-MuiTabs-indicator' : {background: '#0d6703!important'}}}>
                  <Tab label="검사진행안내" {...a11yProps(0)} />
                  <Tab label="주의사항(전날/당일)" {...a11yProps(1)} />
                  <Tab label="항목안내" {...a11yProps(2)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <Box sx={{ textAlign: 'center' }}><img src={information_01} /></Box>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <Box sx={{ textAlign: 'center' }}><img src={information_02} /></Box>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                <Box sx={{ width: 1200, margin: '0 auto', mt: 3 }}>
                  <Table sx={info_table}>
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          <Typography>검진항목에 대한 안내</Typography>
                          <Typography>궁금하신 항목을 선택해 주세요.</Typography>
                        </TableCell>
                        <TableCell>
                          <Box className='item'>
                            <img src={infor_01} />
                            <Typography>기본검사</Typography>
                          </Box>
                          <Box sx={{ display: 'none' }} className="table_active">
                            <Typography>
                              신체계측을 포함한 기본<br />순환기계, 호흡기계, 안과 검사 등을<br />포함한 검사로 우리몸의<br />기초적 기능을 알아보는 검사입니다.</Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className='item'>
                            <img src={infor_02} />
                            <Typography>신장검사</Typography>
                          </Box>
                          <Box sx={{ display: 'none' }} className="table_active">
                            <Typography>
                              신장은 우리 몸에서 대사산물의<br />노폐물 제거, 수분과 염분의 양 조절,<br />내분비계 조절 등 많은 역할을 합니다.<br /><br />
                              이 검사는 크레아티닌, 신사구체여과율,<br />요단백, 요비중 등으로 이뤄져있으며<br />혈액 및 소변 검사로 진행 됩니다.<br /><br />
                              이 검사를 통해 신장의 손상 정도를<br />알아볼 수 있습니다.
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className='item'>
                            <img src={infor_03} />
                            <Typography>일반혈액검사</Typography>
                          </Box>
                          <Box sx={{ display: 'none' }} className="table_active">
                            <Typography>
                              백혈구, 적혈구, 헤모글로빈 등 항목으로<br />이뤄진 일반 혈액검사는 전반적인<br />건강 상태를 알아보는 검사로<br />특정 질병을 선별하거나 진단을<br />확인하고 치료하는데 이용되는<br />기본 검사입니다.
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Box className='item'>
                            <img src={infor_04} />
                            <Typography>심혈관계검사</Typography>
                          </Box>
                          <Box sx={{ display: 'none' }} className="table_active">
                            <Typography>
                              심혈관은 심장과 혈관으로 구성되고<br />심장으로 나온 혈액을 온몸에 공급하여<br />산소, 영양소, 수분 등을 필요한 곳으로<br />공급하는 역할을 합니다.<br />
                              <br />심혈관계 검사는 전해질, 심장효소,<br />지질검사 등으로 이뤄져 있습니다.
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className='item'>
                            <img src={infor_05} />
                            <Typography>간기능/간염검사</Typography>
                          </Box>
                          <Box sx={{ display: 'none' }} className="table_active">
                            <Typography>
                              간은 우리 몸의 대사과정에 중요한 장기로<br />섭취한 음식물을 우리 몸에 필요한<br />영양소 형태로 변화 및 대사 후<br />노폐물을 처리하는 기능을 합니다.<br /><br />
                              간 효소(ALT, AST) 등을 검사하며<br />간의 손상 여부를 확인하며<br />간염검사는 간의 바이러스 감염여부를<br />확인합니다.
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className='item'>
                            <img src={infor_06} />
                            <Typography>당뇨/췌장/빈혈검사</Typography>
                          </Box>
                          <Box sx={{ display: 'none' }} className="table_active">
                            <Typography>
                              공복혈당, 당화색소, 인슐린 검사 등을<br />통해 당뇨 여부를 확인하고<br />췌장 효소 검사로 췌장의<br />기능 검사를 합니다.<br /><br />
                              철, 페르틴 검사 등으로<br />빈혈 여부를 확인합니다.
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className='item'>
                            <img src={infor_07} />
                            <Typography>갑상선/류마티스/통풍검사</Typography>
                          </Box>
                          <Box sx={{ display: 'none' }} className="table_active">
                            <Typography>
                              갑상선 호르몬은 우리 몸의<br />대사 속도를 조절하는 역할을 하며<br />이 검사는 갑상선 호르몬 수치를 통해<br />갑상선 기능 이상 유무를 확인합니다.<br /><br />
                              류마티스 인자와 요산의 수치를 통해<br />류마티스와 통풍의 여부를<br />각각 확인할 수 있는 검사입니다.
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Box className='item'>
                            <img src={infor_08} />
                            <Typography>종양검사</Typography>
                          </Box>
                          <Box sx={{ display: 'none' }} className="table_active">
                            <Typography>
                              이 검사는 우리몸의 종양 여부를<br />확인하는 혈액 검사로<br />난소암, 전립선암, 폐암 등을<br />확인 할 수 있습니다.
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className='item'>
                            <img src={infor_09} />
                            <Typography>비뇨생식계 및 성별 질환</Typography>
                          </Box>
                          <Box sx={{ display: 'none' }} className="table_active">
                            <Typography>
                              이 검사는 남/여 호르몬 수치를<br />확인하여 비뇨생식계 기능을<br />확인하는 검사와 성병 여부를<br />확인 할 수 있는 혈액검사입니다.
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className='item'>
                            <img src={infor_10} />
                            <Typography>장비검사</Typography>
                          </Box>
                          <Box sx={{ display: 'none' }} className="table_active">
                            <Typography>
                              장비검사는 검사 장비를 이용하여<br />질병을 정밀히 검사하는 것으로<br />초음파검사, CT, MRI/MRA 검사를 말합니다.
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className='item'>
                            <img src={infor_11} />
                            <Typography>기타검사</Typography>
                          </Box>
                          <Box sx={{ display: 'none' }} className="table_active">
                            <Typography>
                              선택형 정밀검사에 속하는 검사들로<br />예를 들어 유전자검사,<br />건강나이, 중금속 검사 등 입니다.
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </CustomTabPanel>
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Bottom />
    </Container>
  )
}


const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tab03})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}

const info_table = {

  '& td': { textAlign: 'center', border: '1px solid #ccc', width: '300px!important', height: 300, cursor: 'pointer', position: 'relative', padding: 0 },
  '& td img': { width: 64 },
  '& td p': { mt: 3 },
  '& td:nth-of-type(1)': { cursor: 'default' },
  '& td:nth-of-type(1) p': { mt: 0 },
  '& tr:nth-of-type(1) td:nth-of-type(1) p:nth-of-type(1)': { fontWeight: 'bold', fontSize: 20 },

  '& td:hover .table_active': { display: 'block !important'},
  '& td:hover .table_active p': { fontSize: 14 },
  '& td:hover .item': { display: 'none !important' },
}


export default Information;